import { useTranslation } from "react-i18next";

import { Spacer } from "@aviary";
import { EmersonCategory } from "@shared/components/CatalogSearch/Filters/EmersonCategory/EmersonCategory";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { l } from "@shared/locales/i18n";

import { Allergens } from "../Filters/Allergens/Allergens";
import { Availability } from "../Filters/Availability/Availability";
import { Brands } from "../Filters/Brands/Brands";
import { Form } from "../Filters/Form/Form";
import { Ingredients } from "../Filters/Ingredients/Ingredients/Ingredients";
import { QualityPartners } from "../Filters/QualityPartners/QualityPartners";

import * as styles from "./EmersonFiltersContent.styles";

interface Props {
  logSearchApplyFilterEvent: (entityName: string, entityType: string) => void;
}

const EmersonFiltersContent = ({ logSearchApplyFilterEvent }: Props) => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();

  return (
    <>
      {!!tablet.lessThan && <Spacer height="one" />}
      <EmersonCategory
        logFilterEvent={logSearchApplyFilterEvent}
        customAccordionStyle={styles.accordion}
      />
      <Ingredients
        logFilterEvent={logSearchApplyFilterEvent}
        customAccordionStyle={styles.accordion}
        isBadge
      />
      <Brands logFilterEvent={logSearchApplyFilterEvent} customAccordionStyle={styles.accordion} />
      <Form
        logFilterEvent={logSearchApplyFilterEvent}
        title={t(l.sharedCatalog.filter.DeliverFormat)}
        customAccordionStyle={styles.accordion}
      />
      <Allergens
        logFilterEvent={logSearchApplyFilterEvent}
        title={t(l.sharedCatalog.filter.DietaryConsiderations)}
        customAccordionStyle={styles.accordion}
      />
      <QualityPartners
        logFilterEvent={logSearchApplyFilterEvent}
        customAccordionStyle={styles.accordion}
      />
      <Availability
        logFilterEvent={logSearchApplyFilterEvent}
        customAccordionStyle={styles.accordion}
      />
    </>
  );
};

export { EmersonFiltersContent };
